/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerIndustryDtoSchema = z.object({
  industry: z.optional(z.string()),
  product: z.optional(z.string()),
  verticals: z.optional(z.array(z.string())),
  productCategory: z.optional(z.string()),
  focus: z.optional(z.string()),
});
